/* Zaine hotfix: hide Stamped review 161919868 from Wrinkle Corrector AgeReset Serum until Stamped private API moderation is available. */
(function () {
  var BAD_REVIEW_ID = '161919868';
  var SERUM_PATH = '/products/wrinkle-corrector-agereset-serum';
  function onSerumPage() { return location.pathname.indexOf(SERUM_PATH) !== -1; }
  function hide(el) { if (el) { el.style.setProperty('display','none','important'); el.style.setProperty('visibility','hidden','important'); el.setAttribute('aria-hidden','true'); } }
  function removeBadReview() {
    if (!onSerumPage()) return;
    var selectors = [
      '#stamped-review-' + BAD_REVIEW_ID,
      '[data-review-id="' + BAD_REVIEW_ID + '"]',
      '[review-id="' + BAD_REVIEW_ID + '"]',
      'a[href*="reviewId%3d' + BAD_REVIEW_ID + '"], a[href*="reviewId=' + BAD_REVIEW_ID + '"], a[href*="' + BAD_REVIEW_ID + '"]'
    ];
    selectors.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){
        var card = el.closest('.stamped-review, .stamped-review-container, .stamped-review-card, [id^="stamped-review-"]') || el;
        card.remove();
      });
    });
    // Remove the visible one-star aggregate/summary for this product so customers don't see a dead 1.0 badge.
    document.querySelectorAll('.stamped-main-badge, .stamped-product-reviews-badge, .stamped-badge, .stamped-summary, .stamped-container, #stamped-main-widget').forEach(function(el){
      var txt = (el.innerText || el.textContent || '').toLowerCase();
      var rating = (el.getAttribute('data-rating') || '').toLowerCase();
      var count = (el.getAttribute('data-count') || '').toLowerCase();
      if (txt.indexOf('1 review') !== -1 || txt.indexOf('1.0') !== -1 || txt.indexOf('terrible experience') !== -1 || rating === '1' || count === '1') hide(el);
    });
  }
  removeBadReview();
  var obs = new MutationObserver(removeBadReview);
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
